
import React from 'react';
import Address from '../components/Address';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

function Contact() {

  return (
    <>
      <ContactForm />
      <Address />          
      <Footer />
    </>
  );
}


export default Contact;
